// @flow
import type { AbTestResponse } from '../../sharedTypes';

export const AB_TEST = {
  GWP_AB_TEST_GET: 'ab_test/gwp_ab_test_get',
  GWP_AB_TEST_TRIGGER: 'ab_test/gwp_ab_test_trigger',
  GWP_AB_TEST_REQUEST: 'ab_test/gwp_ab_test_request',
  GWP_AB_TEST_SUCCESS: 'ab_test/gwp_ab_test_success',
  GWP_AB_TEST_FAILURE: 'ab_test/gwp_ab_test_failure',
};

export type GwpAbTestTrigger = {
  type: typeof AB_TEST.GWP_AB_TEST_TRIGGER,
};

export type GwpAbTestRequest = {
  type: typeof AB_TEST.GWP_AB_TEST_REQUEST,
};

export type GwpAbTestSucess = {
  type: typeof AB_TEST.GWP_AB_TEST_SUCCESS,
  payload: AbTestResponse,
};

export type GwpAbTestFailure = {
  type: typeof AB_TEST.GWP_AB_TEST_FAILURE,
  error: string,
};

export function gwpAbTestTrigger(): GwpAbTestTrigger {
  return {
    type: AB_TEST.GWP_AB_TEST_TRIGGER,
  };
}

export function gwpAbTestRequest(): GwpAbTestRequest {
  return {
    type: AB_TEST.GWP_AB_TEST_REQUEST,
  };
}

export function gwpAbTestSucess(payload: AbTestResponse): GwpAbTestSucess {
  return {
    type: AB_TEST.GWP_AB_TEST_SUCCESS,
    payload,
  };
}

export function gwpAbTestFailure(error: string): GwpAbTestFailure {
  return {
    type: AB_TEST.GWP_AB_TEST_FAILURE,
    error,
  };
}
